var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        "content-class": "grv-menu",
        "max-height": "400px"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "text-none ma-0 freq-btn",
                    attrs: {
                      loading: _vm.loading,
                      color: "background darken-1",
                      disabled: _vm.jds.length === 0
                    },
                    on: {
                      click: function($event) {
                        return _vm.getUserJds()
                      }
                    }
                  },
                  on
                ),
                [
                  _c("v-icon", { attrs: { large: "" } }, [
                    _vm._v("person_outline")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticStyle: {
                        "margin-top": "-10px",
                        "margin-left": "-8px",
                        "margin-right": "4px"
                      },
                      attrs: { size: "20" }
                    },
                    [_vm._v("\n\t\t\t\tschedule\n\t\t\t")]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "v-list",
        { staticClass: "pa-0 background darken-1", attrs: { dense: "" } },
        [
          _vm._l(_vm.user_top_jds, function(jd) {
            return [
              _c(
                "v-list-tile",
                {
                  key: jd.name,
                  style:
                    "border-top: 0.5px solid " +
                    _vm.$colors.stringToHsl(jd.name, 70) +
                    ";\n\t\t\t\t\t\t\t\tborder-left: 4px solid " +
                    _vm.$colors.stringToHsl(jd.name, 70) +
                    ";\n\t\t\t\t\t\t\t\tcolor: " +
                    _vm.$colors.stringToHsl(jd.name, 70) +
                    ";",
                  on: {
                    click: function($event) {
                      return _vm.$emit("select-jd", jd.id)
                    }
                  }
                },
                [_c("v-list-tile-title", [_vm._v(_vm._s(jd.name))])],
                1
              )
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43dd02fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43dd02fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/launcher/launcher_frequent_jds.vue
// module id = null
// module chunks = 